<template>
  <content-block class="start-subscription" :loading="loading">
    <div slot="instructions">
      <h5>{{ $t('Start your Subscription') }}</h5>
      <p>{{ $t('Start your subscription and gain access to advanced features, including to our marketplace where you can license over 200 titles on a per-minute basis.') }}</p>
    </div>
    <div class="body-content grid">
      <div v-for="billingOption in billingOptions"
        :key="billingOption.value"
        :class="{ active: selectedBillingOption === billingOption.value }"
        class="billing-option"
        @click="selectedBillingOption=billingOption.value">
        <div class>
          <h6 class="headertitle f-tiny">{{ $t(billingOption.label) }}</h6>
          <p class="price">
            <strong class="priceem">{{ billingOption.price.displayValue }}</strong>
            {{ $t('USD') }}
          </p>
        </div>
        <ul class="featureslist">
          <li v-for="item in billingOption.featureslist" :key="item">{{ $t(item) }}</li>
        </ul>
      </div>
      <div class="actions" v-if="selectedBillingOption">
        <a class="upgradebtn" :href="cardWidgetUrl" target="_blank" rel="noopener">{{ $t('Add Card') }}</a>
        <button
          v-if="creditCard"
          class="upgradebtn"
          type="button"
          name="button"
          :disabled="loading"
          @click="confirmAndProcess"
        >{{ $t('Confirm and Process') }}</button>
      </div>
    </div>
  </content-block>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import { synthesisCardWidgetUrl } from '@/core/helpers/synthesis';
@Component({
  components: {
    ContentBlock,
  },
  props: {
    unitRate: {
      required: true,
    },
    plans: {
      type: Array,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    plan: {
      required: true,
    },
    creditCard: {
      validator (val) {
        return val instanceof Object || val === null || val === undefined;
      },
    },
    open: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
  },
})
export default class StartSubscription extends Vue {
  get cardWidgetUrl () {
    return synthesisCardWidgetUrl(this.organization.synthesisOrgId);
  }

  async confirmAndProcess () {
    const period = this.selectedBillingOption === 'month' ? 1 : 12;
    try {
      await this.$store.dispatch('addSynthesisSubscription', { period });
    } catch (e) {
      // The gql layer surfaces the error to the user; nothing more to do here.
    }
  }

  data () {
    return {
      selectedBillingOption: '',
      billingOptions: [
        {
          value: 'month',
          label: 'Monthly Plan',
          price: {
            amount: 30,
            displayValue: '$30.00',
          },
          featureslist: [
            'Per month, per station',
            'Month-to-month',
            'Cancel anytime',
          ],
        },
        {
          value: 'year',
          label: 'Yearly Plan',
          price: {
            amount: 300,
            displayValue: '$300.00',
          },
          featureslist: [
            'Per year, per station',
            'Year-to-Year',
            'Cancel anytime',
          ],
        },
      ],
    };
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.start-subscription {
  & .headertitle {
    margin-bottom: var(--spacingXS);
  }
  & .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: var(--spacingMd);
    justify-content: space-between;
    align-items: center;
    @media (--tablet) {
      grid-gap: var(--spacingMd);
      grid-template-columns: repeat(2, 1fr);
    }
  }
  & .billing-option {
    text-align: center;
    padding: var(--spacingMd);
    box-shadow: var(--shadowSm);
    border: 1px solid var(--colorGeyser);
    border-radius: var(--radius);
    cursor: pointer;

    &:hover {
      background-color: var(--colorCasper);
    }

    &.active {
      background-color: var(--colorSlate);
      border-color: var(--colorSlate);
      color: var(--colorWhite);

      .featureslist {
        color: var(--colorWhite);
      }
    }
  }
  & .price {
    @apply --f3;
  }
  & .featureslist {
    @apply --f8;
    line-height: 2rem;
    color: var(--colorStorm);
    list-style: none;
    padding-left: 0;
  }
  & .priceem {
    font-size: 3rem;
    font-weight: 600;
  }
  & .upgradebtn {
    @apply --buttonPrimary;
    grid-column: span 2;
    @media (--tablet) {
    }
  }
  & .actions {
    grid-column: span 2;
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacingSm);
    & .upgradebtn {
      flex: 1 1 12rem;
      grid-column: auto;
      text-decoration: none;
      text-align: center;
    }
  }
  & .ccform {
    margin-top: var(--spacingMd);
  }
  & >>> .checkout-summary {
    margin: var(--spacingMd) 0;
  }
}
</style>
